// src/components/posts/PostsHelpfulLinks.tsx
import Link from 'next/link';

export default function PostsHelpfulLinks() {
  const items = [
    { href: '/report', label: 'Report abuse' },
  ];
  return (
    <section aria-labelledby="posts-helpful-links" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 mt-4">
      <h2 id="posts-helpful-links" className="sr-only">Helpful links</h2>
      <ul className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
        {items.map((it) => (
          <li key={it.href} className="inline-flex items-center whitespace-nowrap">
            <Link href={it.href} className="underline">{it.label}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
